<script>
    import { db } from "../../../Database.svelte";
    import RiskToggle from "../../RiskToggle.svelte";
    import {notifier} from '@beyonk/svelte-notifications';
    import {uniq} from "lodash-es";
    import QuestionTypes from "../../../lib/QuestionTypes";

    export let assessment;
    export let assessment_model;
    export let section;

    let section_data = {};
    let dashboard_data;

    let control_map = {};

    function getTagColor(ctrl) {
        let qt_mapping = QuestionTypes[ctrl.question_type];


        let answer = assessment_model.getResult(ctrl.control_id || ctrl.child_id || ctrl.id, '', assessment)?.value;

        if (!(answer && qt_mapping.buttons)) return "";

        return qt_mapping.buttons[answer].color || "";

        switch (assessment_model.getResult(ctrl.control_id || ctrl.child_id, '', assessment)?.value) {
            case "2":
                return "is-success"
            case "1":
                return "is-danger"
            case "3":
                return "is-warning"
            case "-1":
                return "is-dark"
            default:
                return ""
        }
    }

    function save() {
        assessment_model.saveSectionResults(section, section_data).then(() => {
            notifier.success("Report Section Saved")
        });
    }

    function load_data(assessment, section) {
        dashboard_data = assessment.assessment_type_data.dashboards[section.section_name];

        if (assessment.report_data[section.section_name]) {
            section_data = assessment.report_data[section.section_name]
        } else {
            section_data = {};
        }

        section_data.dashboard_items = dashboard_data.data.items.map(item => {
            delete item._id;
            delete item._rev;
            return item;
        });

        // get control mappings

    }

    /*
    async function easy_button() {
        for (let item of dashboard_data.data.items) {
            let item_mappings = [];
            if (dashboard_data.mapping) {
                if (!dashboard_data.mapping[item.item_id]) continue;

                for (let control_mapping of dashboard_data.mapping[item.item_id]) {
                    let control_id = control_mapping.mapped_control.split(":")[4];

                    item_mappings.push(assessment_model.getResult(control_id, '', assessment)?.value);
                }
            }

            item_mappings = uniq(item_mappings);

            if (!item_mappings.includes(undefined)) {
                if (item_mappings.includes("1")) {
                    section_data[item.item_id] = "high";
                } else if (item_mappings.includes("3")) {
                    section_data[item.item_id] = "medium";
                } else {
                    section_data[item.item_id] = "low";
                }
            }
        }
    }
    */

    async function getControl(control_id) {
        let control;
        try {
            control = await db.get(control_id);
        } catch (e) {
            for (let category of $assessment.assessment_type_data.categories) {
                for (let subcategory of category.subcategories) {
                    for (let ctrl of subcategory.controls) {
                        if (ctrl.id == control_id) {
                            control = ctrl;
                            break;
                        }
                    }
                    if (control) break;
                }
                if (control) break;
            }
        }

        if (control && control.library_id) {
            return await db.get(control.library_id);
        } else {
            return control;
        }
    }

    $: load_data($assessment, section);
</script>

<!--<button class="button is-primary" on:click={easy_button}>Auto Fill</button>-->

<div class="columns is-multiline">
    {#if dashboard_data}
        {#each dashboard_data.data.items as item (item.item_id)}
            <div class="column is-2 card">
                <RiskToggle bind:value={section_data[item.item_id]}></RiskToggle>
                <hr>
                <p>{item.Name}</p>
                <hr>
                {#if item.library_mappings}
                    <div class="tags">
                        {#each item.library_mappings as mapping}
                            {#await getControl(mapping.control_id)}
                                Loading...
                            {:then ctrl}
                                {#if ctrl}
                                    <div class="tag {getTagColor(ctrl)}">{ctrl.control_number} {ctrl.name}</div>
                                {/if}
                            {/await}
                        {/each}
                    </div>
                {/if}
                {#if dashboard_data.mapping}
                    <div class="tags">
                        {#each dashboard_data.mapping[item.item_id] || [] as mapping}
                            {#await getControl(mapping.mapped_control)}
                                Loading...
                            {:then ctrl}
                                {#if ctrl}
                                    <div class="tag {getTagColor(ctrl)}">{ctrl.control_number} {ctrl.name}</div>
                                {/if}
                            {/await}
                        {/each}
                    </div>
                {/if}
            </div>
        {/each}
    {/if}
</div>

<button class="button is-pulled-right is-success" on:click={save}>Save</button>


<style>
    .column.card {
        margin: 10px;
    }
</style>